export const fonts = {
  MyriadPro: {
    normal: "Myriad Pro Regular.ttf",
    bold: "Myriad Pro Bold.ttf"
  },
  Poppins : {
    normal: "Poppins-Light.ttf",
    bold: "Poppins-Bold.ttf",
    semiBold: "Poppins-SemiBold.ttf"
  }
}
